export default {
    WARPED_TO: 'Ikaw ay winarp kay {{name}}.',

    CANNOT_WARP_ACHIEVEMENT:
        'Ang warp na ito ay kailangan ng Achievement na dapat tapusin bago ito gamitin.',
    CANNOT_WARP_QUEST: 'Kailangan mong tapusin ang {{questName}} para makapag warp kay {{name}}.',
    CANNOT_WARP_LEVEL: 'Kailangan mo maging atleast level {{level}} para makapag warp dito.',
    CANNOT_WARP_JAIL: 'Hindi ka pwedeng mag-teleport dahil ikaw ay nakulong hanggang {{time}}.',
    CANNOT_WARP_TUTORIAL: 'Kailangan mong tapusin ang tutorial bago makapag warp.',
    CANNOT_WARP_COMBAT:
        'Kailangan mong mag hintay ng Sampung segundo pagkatapos mong lumaban upang makapag warp.',
    CANNOT_WARP_COOLDOWN: 'Kailangan mo mag hintay ng {{time}} para makapag warp.'
} as const;
